import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { LottieShipVerified } from '../Lottie/LottieShipVerified';
import { Text } from 'Views/Components/Text/Text';

export interface RedirectLoaderProps {
	to: string;
	title: string;
	subtitle: string;
	duration?: number;
}

export function RedirectLoader(props: RedirectLoaderProps) {
	const navigate = useNavigate();

	const { to, title, subtitle, duration = 5000 } = props;

	React.useEffect(() => {
		const timeout = setTimeout(() => {
			navigate(to, { replace: true });
		}, duration);

		return () => {
			clearTimeout(timeout);
		};
	}, [to]);

	return (
		<div className="body-content">
			<div className="redirect-loader">
				<div className="redirect-loader__body">
					<LottieShipVerified />
					<div className="redirect-loader__text">
						<Text weight="700" size="xl" className="mb-sm">
							{title}
						</Text>
						<Text weight="500" size="sm" color="gray">
							{subtitle}
						</Text>
					</div>
				</div>
			</div>
		</div>
	);
}
